import * as React from "react";
import { hydrate } from "react-dom";
import { GlobalHeader } from "./patterns/global/header";
var components = [
    ["global-header-container", GlobalHeader],
];
export var setupGlobalComponents = function () {
    for (var _i = 0, components_1 = components; _i < components_1.length; _i++) {
        var _a = components_1[_i], id = _a[0], Component = _a[1];
        hydrate(React.createElement(Component, null), document.getElementById(id));
    }
};



//////////////////
// WEBPACK FOOTER
// ./app/shared/globalComponents.tsx
// module id = seTe
// module chunks = 2